import { render, staticRenderFns } from "./DocumentAttachmentDetailInput.vue?vue&type=template&id=df863016&scoped=true&"
import script from "./DocumentAttachmentDetailInput.vue?vue&type=script&lang=js&"
export * from "./DocumentAttachmentDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAttachmentDetailInput.vue?vue&type=style&index=0&id=df863016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df863016",
  null
  
)

export default component.exports